import { render } from "./completed-form.vue?vue&type=template&id=054f5234&scoped=true&ts=true"
import script from "./completed-form.vue?vue&type=script&lang=ts"
export * from "./completed-form.vue?vue&type=script&lang=ts"

import "./completed-form.vue?vue&type=style&index=0&id=054f5234&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054f5234"]])

export default __exports__